import { WorkspaceMemberModel } from '@/pages/main/components/shareDialog/types';

export class ManageProductsState {
    products: Product[] = [];
    workspaceMembers: WorkspaceMemberModel[] = [];
    isInitialized: boolean = false;
}

export interface Product {
    id: string;
    name: string;
    slug: string;
    memberIds: string[];
    guestIds: string[];
}
